module.exports = __webpack_public_path__ + "static/media/signup_desktop_image.ce97bab8.jpg";